import * as S from './styles'

import CreditCardImage from '../CreditCardImage'

const NewCard = ({ addCreditCard, type, setPaymentModal }) => {
  return (
    <>
      <S.Wrapper
        onClick={() => {
          type === 'modal' ? setPaymentModal(1) : addCreditCard()
        }}
      >
        <S.CardWrapper>
          <S.CardBox className="perfil-box">
            <div className="iconCredit">
              <CreditCardImage />
            </div>

            <S.CardInfo>
              <p>
                <strong>Novo Cartão de Crédito </strong>
                {/* <p>Em até 12x sem juros</p> */}
              </p>
            </S.CardInfo>
          </S.CardBox>
        </S.CardWrapper>
      </S.Wrapper>
    </>
  )
}

export default NewCard
